<div class="content-box">
  <app-breadcrumb pagina="Relatório de Estatísticas"
    [intermediarios]="[{ titulo: 'Ouvidoria', link: '/ouvidoria' }]"></app-breadcrumb>

  <div class="element-wrapper">
    <div class="title-wrapper">
      <h1 class="estat-titulo">Relatório de Estatísticas da Ouvidoria</h1>
    </div>
  </div>

  <br />

  <div class="element-box mt-2">
    <div class="d-flex justify-content-between align-items-center">
      <h6 class="title-filter">
        <i-lucide name="funnel" color="var(--primary-color)"></i-lucide> Filtros de Busca
      </h6>
      <button type="button" class="btn btn-sm btn-outline-primary rounded-3" (click)="limparFiltros()">
        <strong style="font-size: 12px;">Limpar Filtros</strong>
      </button>
    </div>

    <form (ngSubmit)="aplicarFiltros()">
      <div class="row g-3 align-items-end filtros-bar">
        <div class="col-12 col-sm-4">
          <label for="dataInicio" class="form-label">Data inicial:</label>
          <input type="date" class="form-control filtro-control" id="dataInicio" name="dataInicio"
            [(ngModel)]="dataInicio" />
        </div>

        <div class="col-12 col-sm-4">
          <label for="dataFim" class="form-label">Data final:</label>
          <input type="date" class="form-control filtro-control" id="dataFim" name="dataFim" [(ngModel)]="dataFim" />
        </div>

        <div class="col-12 col-sm-4">
          <label for="tipoSelect" class="form-label">Tipo de manifestação:</label>
          <select class="form-control filtro-control" id="tipoSelect" name="tipoSelecionado"
            [(ngModel)]="tipoSelecionado">
            <option value="">Todos</option>
            @for (tipo of tipos; track tipo.value) {
            <option [value]="tipo.value">{{ tipo.label }}</option>
            }
          </select>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <button id="btn-pesquisar" class="btn btn-sm btn-aplicar-filtros" type="submit">
            Aplicar Filtros
          </button>
        </div>
      </div>
    </form>
  </div>

  <br />

  <div class="row g-3 mb-4">
    <div class="col-sm-4">
      <div class="card h-100 border-0 shadow-sm estat-card">
        <div class="card-body d-flex flex-column justify-content-between">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="estat-card-title">Manifestações Recebidas</span>
          </div>
          <div class="d-flex justify-content-between">
            <div>
              <div class="estat-card-label text-muted">Total</div>
              <div class="estat-card-value">{{ dados().length }}</div>
            </div>
            <div class="estat-card-divider"></div>
            <div>
              <div class="estat-card-label text-muted">Prazo</div>
              <div class="estat-card-value estat-card-value-prazo">
                {{ tempoMedioResposta() }} <span class="fw-bold">Dias</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="card h-100 border-0 shadow-sm estat-card">
        <div class="card-body d-flex flex-column justify-content-between">
          <span class="estat-card-title">Manifestações Respondidas</span>
          <div class="estat-card-value mt-2 mb-1">{{ manifestacoesRespondidas() }}</div>
          <div class="d-flex justify-content-between align-items-center mb-1">
            <span class="estat-card-label">{{ percentualRespondidas() }}% total</span>
            <span class="estat-card-label">{{ manifestacoesRespondidas() }}/{{ dados().length }}</span>
          </div>
          <div class="progress estat-card-progress">
            <div class="progress-bar bg-dark" role="progressbar" aria-label="Percentual de manifestações respondidas"
              aria-valuemin="0" aria-valuemax="100" [style.width.%]="percentualRespondidas()"
              [attr.aria-valuenow]="percentualRespondidas()"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-4 position-relative">
      <div class="card h-100 border-0 shadow-sm estat-card">
        <div class="card-body d-flex flex-column justify-content-between ilustracao-card">
          <span class="estat-card-title">Dentro do Prazo</span>
          <div class="estat-card-value mt-2 mb-1">{{ manifestacoesNaoRespondidasNoPrazo() }}</div>
          <div class="d-flex justify-content-between align-items-center mb-1">
            <span class="estat-card-label">{{ percentualNaoRespondidasNoPrazo() }}% no prazo</span>
            <span class="estat-card-label">
              {{ manifestacoesNaoRespondidasNoPrazo() }}/{{ manifestacoesNaoRespondidas().length }}
            </span>
          </div>
          <div class="progress estat-card-progress">
            <div class="progress-bar bg-dark" role="progressbar"
              aria-label="Percentual de manifestações em aberto dentro do prazo" aria-valuemin="0" aria-valuemax="100"
              [style.width.%]="percentualNaoRespondidasNoPrazo()"
              [attr.aria-valuenow]="percentualNaoRespondidasNoPrazo()"></div>
          </div>
        </div>
      </div>

      <img class="ilustracao-estat-card position-absolute"
        src="assets/images/ouvidoria/ilustracao-estatisticas-ouvidoria.png" width="110" height="110" alt="" />
    </div>
  </div>

  <div class="row g-3 mb-4">
    <div class="col-sm-8">
      <div class="card mb-4">
        <div class="card-body">
          <h3 class="card-title mb-3 h4">Tipo de manifestações</h3>
          <div #graficoTipoManifestacoes></div>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="row g-3 mb-4 flex-column align-items-end">
        <div class="col-12">
          <div class="card border-0 estat-card">
            <div class="card-body py-3 px-3">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="estat-card-title">Sugestões</span>
              </div>
              <div class="d-flex align-items-center">
                <span class="estat-card-value me-3">{{ dadosGrafico().sugestao }}</span>
                <div class="estat-card-progress flex-grow-1">
                  <div class="progress-bar bg-dark" [style.width.%]="getPercentual(dadosGrafico().sugestao)"></div>
                  <div class="progress-bar bg-pink" [style.width.%]="100 - getPercentual(dadosGrafico().sugestao)">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card border-0 estat-card">
            <div class="card-body py-3 px-3">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="estat-card-title">Elogios</span>
              </div>
              <div class="d-flex align-items-center">
                <span class="estat-card-value me-3">{{ dadosGrafico().elogio }}</span>
                <div class="estat-card-progress flex-grow-1">
                  <div class="progress-bar bg-dark" [style.width.%]="getPercentual(dadosGrafico().elogio)"></div>
                  <div class="progress-bar bg-pink" [style.width.%]="100 - getPercentual(dadosGrafico().elogio)">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card border-0 estat-card">
            <div class="card-body py-3 px-3">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="estat-card-title">Reclamações</span>
              </div>
              <div class="d-flex align-items-center">
                <span class="estat-card-value me-3">{{ dadosGrafico().reclamacao }}</span>
                <div class="estat-card-progress flex-grow-1">
                  <div class="progress-bar bg-dark" [style.width.%]="getPercentual(dadosGrafico().reclamacao)"></div>
                  <div class="progress-bar bg-pink" [style.width.%]="100 - getPercentual(dadosGrafico().reclamacao)">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card border-0 estat-card">
            <div class="card-body py-3 px-3">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="estat-card-title">Denúncias</span>
              </div>
              <div class="d-flex align-items-center">
                <span class="estat-card-value me-3">{{ dadosGrafico().denuncia }}</span>
                <div class="estat-card-progress flex-grow-1">
                  <div class="progress-bar bg-dark" [style.width.%]="getPercentual(dadosGrafico().denuncia)"></div>
                  <div class="progress-bar bg-pink" [style.width.%]="100 - getPercentual(dadosGrafico().denuncia)">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br />

  <div class="row g-3 mb-4">
    <div class="col-sm-12">
      <div class="card mb-4">
        <div class="card-body">
          <h3 class="card-title mb-3 h4">Principais Assuntos</h3>
          <div #graficoAssuntos></div>
        </div>
      </div>
    </div>

    <div class="col-sm-12 mt-3">
      <div class="card mb-4">
        <div class="card-body">
          <h3 class="card-title mb-3 h4">Tendência Mensal</h3>
          <div #graficoTendenciaMensal></div>
        </div>
      </div>
    </div>
  </div>
</div>